import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useApolloClient, useMutation, useQuery } from 'react-apollo';

import { MeQuery } from '../../../../../graphql/queries/account';
import {
  accountUpdate as accountUpdateMutation,
  accountLoginByPhone as accountLoginByPhoneMutation,
  signupEventCreateReminderSet as signupEventCreateReminderSetMutation,
  eventAddonPurchaseReminderSet as eventAddonPurchaseReminderSetMutation,
} from '../../../../../graphql/mutations/account';
import { loginSuccess } from '../../../../../actions/auth-actions';
import useAuthenticated from '../../../../../hooks/useAuthenticated';
import { SESSION_STATE } from '../helpers';
import { getPhotoSearchCheckoutSearchItemsQuery } from '../../../../temp/views/onboarding/PhotoSearchCheckout/graphql/queries/getPhotoSearchCheckoutSearchItems';
import useEmailPinAuth from '../../../../../components/auth/hooks/useEmailPinAuth';

const useSignupAlbumCreate = () => {
  const dispatch = useDispatch();
  const client = useApolloClient();
  const authenticated = useAuthenticated();
  const onLogin = useCallback(() => dispatch(loginSuccess()));
  const { data: { me: user } = {} } = useQuery(MeQuery, {
    skip: !authenticated,
    fetchPolicy: 'cache-and-network',
  });
  const [accountUpdate] = useMutation(accountUpdateMutation);
  const [accountLoginByPhone] = useMutation(accountLoginByPhoneMutation);
  const [signupEventCreateReminderSet] = useMutation(
    signupEventCreateReminderSetMutation,
  );
  const [eventAddonPurchaseReminderSet] = useMutation(
    eventAddonPurchaseReminderSetMutation,
  );
  const { data: { searchSubscriptionItems = [] } = {} } = useQuery(
    getPhotoSearchCheckoutSearchItemsQuery,
  );
  const { onLoginByEmail } = useEmailPinAuth();

  const onAccountUpdate = async input => {
    const res = accountUpdate({
      variables: {
        input,
      },
    });

    return res;
  };

  const onPinVerify = async input => {
    const res = await accountLoginByPhone({
      variables: {
        input,
      },
    });

    return res;
  };

  const onSignIn = async () => {
    const {
      data: { me: signedInUser },
    } = await client.query({
      query: MeQuery,
      fetchPolicy: 'network-only',
    });

    if (signedInUser) {
      onLogin();
    }

    return signedInUser;
  };

  const onSignupEventCreateReminderSet = async ({
    eventType,
    sessionState = SESSION_STATE.START,
  }) => {
    await signupEventCreateReminderSet({
      variables: {
        input: {
          album_subtype: eventType,
          session_state: sessionState,
        },
      },
    });
  };

  const onEventAddonPurchaseReminderSet = async ({
    hierarchyItemId,
    sessionState = SESSION_STATE.START,
  }) => {
    await eventAddonPurchaseReminderSet({
      variables: {
        input: {
          hierarchy_item_id: hierarchyItemId,
          session_state: sessionState,
        },
      },
    });
  };

  return {
    user,
    onAccountUpdate,
    onPinVerify,
    onLoginByEmail,
    onSignIn,
    onSignupEventCreateReminderSet,
    onEventAddonPurchaseReminderSet,
    searchSubscriptionItems,
  };
};

export default useSignupAlbumCreate;
